
import React, { useCallback, useEffect, useState} from 'react';
import { Card, CardContent, Typography, Box, Divider } from '@mui/material';
import { useWasteManagement, WasteManagementContext, WasteManagementType } from '../../../ContextAPI/WasteManagementContext';
import dayjs from 'dayjs';
import { FetchBinCardReport } from '../../../ApiServices/ApiRequests';
import { useTranslation } from 'react-i18next';
import { BinOverviewReportCard } from '../../../Models/Models';
import { useMasterData } from '../../../ContextAPI/MasterContext';
import Loading from '../../../Controller/LoadingController/Loading';


const BinMonitoringCard: React.FC = () => {
  const { masterState } = useMasterData();

  const { wasteManagementState, dispatchWasteManagement } =
    useWasteManagement();
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  const handleBulkUpdate = useCallback(
    (value: Partial<WasteManagementType>) => {
      dispatchWasteManagement({ type: "BULK_UPDATE", value });
    },
    [dispatchWasteManagement]
  );

  const fetchData = async (
    siteCode: string,
    fromDate: string,
    groupId: string
  ): Promise<void> => {
    try {
      setLoading(true);
      const data: BinOverviewReportCard = await FetchBinCardReport(
        siteCode,
        fromDate,
        groupId
      );
      // Check if data.content has entries, and if so, process the report data
      const reportData =
        data && data
          ? {
              totalBinMoniterValue: data.totalValue,
              totalBinValueChanges: data.totalValueChanges,
              totalBinValueColor: data.totalValueColor,
              averageFillBinlabel: data.avgValue,
              avgBinValueChanges: data.avgValueChanges,
              avgBinValueColor: data?.avgValueColor,

              // Ensure siteData is an empty array if report is undefined
            }
          : {
              totalBinMoniterValue: 0,
              totalBinValueChanges: "",
              totalBinValueColor: "",
              averageFillBinLabel: 0,
              avgBinValueChanges: "",
              avgBinValueColor: "",
              // Set siteData as an empty array if content is empty
            };

      // Dispatch the data with handleBulkUpdate
      handleBulkUpdate(reportData);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const formattedDate: string = masterState.reportSelectedDate
      ? masterState.reportSelectedDate.format("YYYY-MM-DD")
      : "";
    
    if(masterState.selectedSiteCode.length>0 ){
    fetchData(masterState.selectedSiteCode,
      formattedDate ,masterState.selectedGroupCode);
    }
  }, [masterState.selectedSiteCode,masterState.selectedGroupCode,masterState.reportSelectedDate]);

  return (
    <>
      {loading ? (
        <Loading loading={loading} type={`dots`} backDrop={false} />
      ) : (
        <Box display="flex" gap={2} bgcolor={"#f9f9f9"} p={1} mt={2}>
          <Card
            sx={{
              display: "flex",
              borderLeft: "4px solid #8850ef",
              minWidth: 250,
              ml: 3,
              maxHeight: 130,
            }}
          >
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                {t("global.TotalBinMonitired")}
              </Typography>
              <Typography variant="h5">
                {t("global.Value")}:{" "}
                {wasteManagementState.totalBinMoniterValue ?? 0}
              </Typography>
              <Typography color={wasteManagementState.totalBinValueColor}>
                {wasteManagementState.totalBinValueChanges ?? 0}
              </Typography>
            </CardContent>
          </Card>

          <Card
            sx={{
              display: "flex",
              borderLeft: "4px solid #8850ef",
              minWidth: 250,
              maxHeight: 130,
            }}
          >
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                {t("global.AverageFillLevel")}
              </Typography>
              <Typography variant="h5">
                {wasteManagementState.averageFillBinlabel
                  ? `${wasteManagementState.averageFillBinlabel}%`
                  : 0}
              </Typography>
              <Typography color={wasteManagementState.avgBinValueColor}>
                {wasteManagementState.avgBinValueChanges ?? 0}
              </Typography>
            </CardContent>
          </Card>
        </Box>
      )}
    </>
  );
};

export default BinMonitoringCard;
